import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icon-back.svg'


const _withScopeId = n => (_pushScopeId("data-v-439e5cf0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-row" }
const _hoisted_2 = { class: "w-full lg:w-6/7 mx-auto h-auto" }
const _hoisted_3 = { class: "sm:px-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-[12px]" }, "Volver", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between items-center my-3" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-[16px] font-semibold" }, "Mis dividendos")
], -1))
const _hoisted_7 = { class: "w-full h-full overflow-auto" }
const _hoisted_8 = { class: "table-auto w-full" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "border-thead" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "font-bold whitespace-nowrap px-4 py-2 text-left text-[16px]" }, " N° Dividendo "),
    /*#__PURE__*/_createElementVNode("th", { class: "font-bold whitespace-nowrap px-4 py-2 text-left text-[16px]" }, " Fecha "),
    /*#__PURE__*/_createElementVNode("th", { class: "font-bold whitespace-nowrap px-4 py-2 text-right text-[16px]" }, " Total de acciones "),
    /*#__PURE__*/_createElementVNode("th", { class: "font-bold whitespace-nowrap px-4 py-2 text-right text-[16px]" }, " UF por acción "),
    /*#__PURE__*/_createElementVNode("th", { class: "font-bold whitespace-nowrap px-4 py-2 text-right text-[16px]" }, " CLP por acción "),
    /*#__PURE__*/_createElementVNode("th", { class: "font-bold whitespace-nowrap px-4 py-2 text-right text-[16px]" }, " Rentabilidad Total "),
    /*#__PURE__*/_createElementVNode("th", { class: "font-bold whitespace-nowrap px-4 py-2 text-right text-[16px]" }, " Rentabilidad Real "),
    /*#__PURE__*/_createElementVNode("th", { class: "font-bold whitespace-nowrap px-4 py-2 text-right text-[16px]" }, " Monto UF "),
    /*#__PURE__*/_createElementVNode("th", { class: "font-bold whitespace-nowrap px-4 py-2 text-right text-[16px]" }, " Monto CLP "),
    /*#__PURE__*/_createElementVNode("th", { class: "font-bold whitespace-nowrap px-4 py-2 text-right text-[16px]" }, " Acumulado CLP "),
    /*#__PURE__*/_createElementVNode("th", { class: "font-bold whitespace-nowrap px-4 py-2 text-right text-[16px]" }, " Cuenta destino "),
    /*#__PURE__*/_createElementVNode("th", { class: "font-bold whitespace-nowrap px-4 py-2 text-left text-[16px]" }, " Estado ")
  ])
], -1))
const _hoisted_10 = { class: "text-[16px] whitespace-nowrap text-left py-2 sm:px-4" }
const _hoisted_11 = { class: "text-[16px] whitespace-nowrap text-left py-2 px-4" }
const _hoisted_12 = { class: "text-[16px] whitespace-nowrap py-2 px-4 text-end" }
const _hoisted_13 = { class: "text-[16px] whitespace-nowrap py-2 px-4 text-end" }
const _hoisted_14 = { class: "text-[16px] whitespace-nowrap py-2 px-4 text-end" }
const _hoisted_15 = { class: "text-[16px] whitespace-nowrap py-2 px-4 text-right" }
const _hoisted_16 = { class: "text-[16px] whitespace-nowrap py-2 px-4 text-right" }
const _hoisted_17 = { class: "text-[16px] whitespace-nowrap py-2 px-4 text-right" }
const _hoisted_18 = { class: "text-[16px] whitespace-nowrap py-2 px-4 text-right" }
const _hoisted_19 = { class: "text-[16px] whitespace-nowrap text-right py-2 px-4" }
const _hoisted_20 = { class: "text-[16px] whitespace-nowrap text-right py-2 px-4" }
const _hoisted_21 = { class: "text-[16px] whitespace-nowrap font-semibold text-left py-2 px-4" }
const _hoisted_22 = {
  key: 0,
  class: "text-center text-[16px] mt-2"
}

import { onMounted, computed, ref, Ref } from "vue";
import { storeToRefs } from "pinia";
import { useRouter } from "vue-router";

import { useDividendsStore } from "@/stores/dividend";

import {
  reformatDate,
  formatNumber,
  toBadgeFormat,
  toBadgeFormatUf,
} from "@/services/utils";

import PaginationControl from "@/components/atoms/PaginationControl.vue";

import moment from "moment";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShareholderDividendsTable',
  setup(__props) {

const router = useRouter();

const dividendsStore = useDividendsStore();
const { activeAccount, pagination, dividends } = storeToRefs(dividendsStore);

const handleSetPage = (page: number) => {
  pagination.value.page = page;
  dividendsStore.fetchDividends();
};

onMounted(() => {
  dividendsStore.fetchDividends();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            class: "total-balance view-movement flex items-center justify-start gap-4",
            "active-class": "font-bold text-green-700",
            to: { name: 'MyStocks' }
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _hoisted_5
            ]),
            _: 1
          }),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("table", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dividends), (dividend) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: dividend.id,
                    class: "hover:bg-gray-100 cursor-pointer gap-5"
                  }, [
                    _createElementVNode("td", _hoisted_10, _toDisplayString(dividend.dividendCode ?? "-"), 1),
                    _createElementVNode("td", _hoisted_11, _toDisplayString(dividend.pendingDate
                      ? _unref(moment)(dividend.pendingDate).format("DD/MM/YYYY")
                      : "-"), 1),
                    _createElementVNode("td", _hoisted_12, _toDisplayString(dividend.totalShares
                      ? _unref(toBadgeFormat)(dividend.totalShares)
                      : "-"), 1),
                    _createElementVNode("td", _hoisted_13, _toDisplayString(dividend.totalShares
                      ? _unref(toBadgeFormatUf)(dividend.totalUf / dividend.totalShares)
                      : "-"), 1),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(dividend.totalShares
                      ? "$" +
                        _unref(toBadgeFormat)(dividend.totalClp / dividend.totalShares)
                      : "-"), 1),
                    _createElementVNode("td", _hoisted_15, _toDisplayString(dividend.totalProfitability
                      ? `${_unref(formatNumber)(dividend.totalProfitability)}%`
                      : "-"), 1),
                    _createElementVNode("td", _hoisted_16, _toDisplayString(dividend.realProfitability
                      ? `${_unref(formatNumber)(dividend.realProfitability)}%`
                      : "-"), 1),
                    _createElementVNode("td", _hoisted_17, _toDisplayString(dividend.totalUf ? _unref(toBadgeFormatUf)(dividend.totalUf) : "-"), 1),
                    _createElementVNode("td", _hoisted_18, _toDisplayString(dividend.totalClp
                      ? "$" + _unref(toBadgeFormat)(dividend.totalClp)
                      : "-"), 1),
                    _createElementVNode("td", _hoisted_19, _toDisplayString(dividend.dividendBalanceClp ? `$${_unref(toBadgeFormat)(dividend.dividendBalanceClp)}` : "-"), 1),
                    _createElementVNode("td", _hoisted_20, _toDisplayString(dividend.accountNumber ?? '-'), 1),
                    _createElementVNode("td", _hoisted_21, _toDisplayString(dividend.status
                      ? _unref(dividendsStore).getPrettyPrintStatus(dividend.status)
                      : "-"), 1)
                  ]))
                }), 128))
              ])
            ]),
            (_unref(activeAccount) == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, " Por favor seleccione una cuenta "))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(PaginationControl, {
      selectedPage: _unref(pagination).page,
      perPage: _unref(pagination).per_page,
      totalPages: _unref(pagination).total_pages,
      onSetPage: handleSetPage
    }, null, 8, ["selectedPage", "perPage", "totalPages"])
  ], 64))
}
}

})